"use client"
/* */
const locales = {"de-DE": {  "action.isFailed": `Fehlgeschlagen`,
  "action.isPending": `Ausstehend...`,
  "action.isSucceeded": `Erfolgreich`,
},"en-US": {  "action.isFailed": `Failed`,
  "action.isPending": `Pending...`,
  "action.isSucceeded": `Succeeded`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@8b26c19d587a90f821a2307c8122f6d1.mjs.map
